<template>
  <v-card class="maintenance-card" elevation="8">
    <v-card-text class="text-center pa-8">
      <v-icon size="80" color="primary" class="mb-4">
        mdi-information-outline
      </v-icon>
      <h2 class="maintenance-title mb-4">Online Booking Unavailable</h2>
      <p class="maintenance-message mb-6" v-if="msg">
        <template v-for="(part, index) in msgParts">
          <a v-if="part.isLink" :key="index" :href="part.text">{{
            part.text
          }}</a>
          <span v-else :key="index">{{ part.text }}</span>
        </template>
      </p>
      <p class="maintenance-message mb-6" v-else>
        Online booking is currently unavailable. Please check back later.
      </p>
      <v-divider class="mb-4"></v-divider>
      <p class="maintenance-footer">
        You can still log in to view your existing bookings and tickets.
      </p>
    </v-card-text>
  </v-card>
</template>
<script>
import { linkifyParts } from "../helpers";

export default {
  name: "Maintenance",
  props: {
    msg: {
      type: String,
      default: "",
    },
  },
  computed: {
    msgParts() {
      return linkifyParts(this.msg);
    },
  },
};
</script>

<style scoped>
.maintenance-card {
  max-width: 600px;
  margin: 20px auto;
  border-radius: 16px !important;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border: 2px solid #2196f3;
}

.maintenance-title {
  color: #0d47a1;
  font-weight: 600;
  font-size: 28px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.maintenance-message {
  color: #1565c0;
  font-size: 18px;
  line-height: 1.6;
  font-weight: 400;
  max-width: 500px;
  margin: 0 auto;
  overflow-wrap: anywhere;
}

.maintenance-message a {
  color: #0d47a1;
  font-weight: 600;
}

.maintenance-footer {
  color: #37474f;
  font-size: 14px;
  font-style: italic;
  opacity: 0.8;
}

@media (max-width: 600px) {
  .maintenance-card {
    margin: 10px;
  }

  .maintenance-title {
    font-size: 24px;
  }

  .maintenance-message {
    font-size: 16px;
  }
}
</style>
